import React from "react";

interface FloatingActionButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children?: React.ReactNode;
  variant?: "primary" | "secondary" | "default";
  className?: string;
  position?: "bottom-right" | "bottom-left" | "top-right" | "top-left";
}

function FloatingActionButton({
  children,
  variant = "primary",
  className = "",
  position = "bottom-right",
  ...props
}: FloatingActionButtonProps) {
  const buttonClass = () => {
    switch (variant) {
      case "secondary":
        return "shadow-lg bg-white text-electrum border-2 border-electrum hover:bg-electrum hover:text-white hover:border-electrum focus:text-white focus:bg-electrum focus:border-electrum focus:outline-none disabled:bg-gray-400 disabled:cursor-not-allowed";
      case "default":
        return "shadow-lg bg-gray text-white hover:bg-gray-hover focus:bg-gray-focus focus:outline-none focus:ring disabled:bg-gray-400 disabled:cursor-not-allowed";
      default:
        return "shadow-lg bg-electrum text-white hover:bg-electrum-300 focus:bg-electrum-focus focus:outline-none focus:ring disabled:bg-gray-400 disabled:cursor-not-allowed";
    }
  };

  const positionClass = () => {
    switch (position) {
      case "bottom-left":
        return "bottom-6 left-6";
      case "top-right":
        return "top-6 right-6";
      case "top-left":
        return "top-6 left-6";
      default:
        return "bottom-6 right-6";
    }
  };

  return (
    <button
      {...props}
      className={`${buttonClass()} ${positionClass()} fixed rounded-full flex items-center justify-center transition-all duration-200 ease-in-out z-50 ${className}`}
      disabled={props.disabled}
    >
      {children}
    </button>
  );
}

export default FloatingActionButton;
